$(document).ready(function () {
  // remove tabindex from iframe in the homepage video
    let observer = new MutationObserver(function (mutations) {
        $(".video-wrapper iframe").each(function () {
            if ($(this).attr("tabindex") === "-1") {
                $(this).removeAttr("tabindex");
                console.log("Tabindex removed from dynamically loaded iframe");
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
                const element = mutation.target;
                const isHidden = element.getAttribute("aria-hidden") === "true";
                const anchor = element.querySelector(".announcement-bar a");
                // Homepage text slideshow anchor
                const homeSlideAnchor = element.querySelector(".text-slideshow .button.button--primary");

                if (anchor) {
                    if (isHidden) {
                        anchor.setAttribute("tabindex", "-1");
                    } else {
                        anchor.removeAttribute("tabindex");
                    }
                }
                // Homepage text slideshow anchor
                if (homeSlideAnchor) {
                    if (isHidden) {
                        homeSlideAnchor.setAttribute("tabindex", "-1");
                    } else {
                        homeSlideAnchor.removeAttribute("tabindex");
                    }
                }
            }
        });
    });

    // Select all announcement bars
    document.querySelectorAll(".announcement-bar").forEach((bar) => {
        observer.observe(bar, { attributes: true, attributeFilter: ["aria-hidden"] });
    });

    // Homepage text slideshow anchor
    document.querySelectorAll(".text-slideshow__slide").forEach((slide) => {
        observer.observe(slide, { attributes: true, attributeFilter: ["aria-hidden"] });
    });
});

/* You may also like section js on product page */
/*document.addEventListener("DOMContentLoaded", function () {
    function updateInertAttribute(galleryCell) {
        let isHidden = galleryCell.getAttribute("aria-hidden") === "true";

        let imageAnchor = galleryCell.querySelector(".product-image__wrapper a");
        let quickAnchor = galleryCell.querySelector(".product-quick-shop");
        let titleAnchor = galleryCell.querySelector(".product-thumbnail__title");

        if (imageAnchor) {
            if (isHidden) {
                imageAnchor.setAttribute("tabindex", "-1");
            } else {
                imageAnchor.removeAttribute("tabindex");
            }
        }
        if (quickAnchor) {
            if (isHidden) {
                quickAnchor.setAttribute("tabindex", "-1");
            } else {
                quickAnchor.removeAttribute("tabindex");
            }
        }
        if (titleAnchor) {
            if (isHidden) {
                titleAnchor.setAttribute("tabindex", "-1");
            } else {
                titleAnchor.removeAttribute("tabindex");
            }
        }
    }

    // **Wait for Flickity to load completely**
    setTimeout(() => {
        console.log("Flickity loaded, applying accessibility fixes...");
        
        // **1. Handle all `.gallery-cell` on page load**
        document.querySelectorAll(".gallery-cell").forEach(updateInertAttribute);

        // **2. Setup MutationObserver for dynamic changes**
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
                    updateInertAttribute(mutation.target);
                }
            });
        });

        // **3. Attach observer to all `.gallery-cell` elements**
        document.querySelectorAll(".gallery-cell").forEach(function (cell) {
            observer.observe(cell, { attributes: true, attributeFilter: ["aria-hidden"] });
        });
    }, 10000); // Adjust timeout as needed (1000ms = 1s)

});*/

// Product page radio buttons
function updateSwatchAriaChecked() {
  document.querySelectorAll('.product_form [data-variant-option-value-wrapper]').forEach(wrapper => {
    const input = wrapper.querySelector('.product_form input[type="radio"]');
    const swatchDiv = wrapper.querySelector('.product_form [role="radio"]');

    if (input && swatchDiv) {
      swatchDiv.setAttribute('aria-checked', input.checked ? 'true' : 'false');
    }
  });
}

// Run on page load
updateSwatchAriaChecked();

// Run on change (when user selects a new swatch)
document.querySelectorAll('.product_form input[type="radio"][data-variant-option-value]').forEach(input => {
  input.addEventListener('change', updateSwatchAriaChecked);
});

// Product card quick view focus on collection pages
document.addEventListener('keydown', function (event) {

  const quickView = event.target.closest('.product-image__wrapper .js-quick-shop-link');

  if (!quickView) return;

  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    quickView.click();
  }

});

// Product page color swatches
document.addEventListener('change', function(event) {
  const radio = event.target;
  if (!radio.matches('[data-variant-option-value]')) return;

  setTimeout(() => {
    radio.focus();
  }, 0);
});



// Checkout button on cart page
document.addEventListener('DOMContentLoaded', function () {

  const checkoutBtn = document.querySelector('.cart__checkout .add_to_cart');

  if (!checkoutBtn) return;

  checkoutBtn.addEventListener('keydown', function (e) {

    if (e.key === 'Enter') {
      e.preventDefault();

      // Trigger native checkout button click
      this.click();
    }
  });
});

// Product quantity(+,-) keyboard accessiblity issue
document.addEventListener('keydown', function (event) {

  const button = event.target.closest(
    '.quantity-minus, .quantity-plus'
  );

  if (!button) return;

  if (event.key === 'Enter' || event.key === ' ') {

    event.preventDefault();

    const quantityBox = button.closest(
      '.product-quantity-box'
    );

    if (!quantityBox) return;

    // Save focused button type
    const isPlus = button.classList.contains('quantity-plus');

    // Save line item identifier
    const lineItemKey = quantityBox.dataset.lineItemKey;

    // Trigger existing theme logic
    button.click();

    // Wait for AJAX/cart rerender
    setTimeout(() => {

      const updatedQuantityBox = document.querySelector(
        '.product-quantity-box[data-line-item-key="' +
        lineItemKey +
        '"]'
      );

      if (!updatedQuantityBox) return;

      const focusButton = updatedQuantityBox.querySelector(
        isPlus
          ? '.quantity-plus'
          : '.quantity-minus'
      );

      if (focusButton) {
        focusButton.focus();
      }

    }, 500);
  }
});

document.addEventListener('DOMContentLoaded', function () {

  const quantityButtons = document.querySelectorAll(
    '.cart__quantity .quantity-minus, .cart__quantity .quantity-plus'
  );

  quantityButtons.forEach(function (button) {

    button.addEventListener('keydown', function (event) {

      if (event.key === 'Enter' || event.key === ' ') {

        // Prevent cart form submission
        event.preventDefault();
        event.stopPropagation();

        // Trigger existing click logic
        this.click();
      }
    });
  });

});
/*document.addEventListener('keydown', function (event) {
  const button = event.target.closest(
    '.quantity-minus, .quantity-plus'
  );
  if (!button) return;

  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    const wrapper = button.closest('.quantity-wrapper');
    if (!wrapper) return;
    const input = wrapper.querySelector('.quantity-input');
    if (!input) return;
    let value = parseInt(input.value, 10) || 1;

    // Increase quantity
    if (button.classList.contains('quantity-plus')) {
      value++;
    }

    // Decrease quantity
    if (button.classList.contains('quantity-minus') && value > 1) {
      value--;
    }

    input.value = value;

    input.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

});*/

// Close button fix on cart page
document.addEventListener('keyup', function(event) {

  const removeButton = event.target.closest(
    '.cart__remove .ajax-cart__delete'
  );

  if (!removeButton) return;

  if (event.key === 'Enter') {

    event.preventDefault();
    event.stopImmediatePropagation();

    const removeUrl = removeButton.dataset.removeUrl;

    if (removeUrl) {
      window.location.assign(removeUrl);
    }
  }

});